module.exports = __webpack_public_path__ + "img/58200.00600cd4.jpg";